import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Components
import IndexPageMainContainer from '../../components/index/IndexPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import { CompanyName } from '../../utils/Constants';
// Meta
import {
  indexPageAdditionalMeta,
  indexPageStructuredData,
} from '../../utils/data/MetaData';

const IndexPage = React.memo(() => {
  usePageTracking(); // Tracks page views

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Enter'
        desc={`Entrance to ${CompanyName}. Adults 18+ only. By entering, you confirm you understand and accept the site’s terms and age requirements.`}
        keywords={`enter, ${CompanyName}, dominatrix, BDSM, age verification, adult site`}
        additionalMeta={indexPageAdditionalMeta}
        structuredData={indexPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen h-screen max-h-screen overflow-hidden bg-colour2 font-poppins no__highlights'>
        {/* Main page content */}
        <IndexPageMainContainer />
      </div>
    </>
  );
});

export default IndexPage;
